import { useRequestURL } from '#imports'

import type { ArticleCard } from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.types'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import {
  COMPARE_PAGE_RELATED_ARTICLES_LIST_ID,
  COMPARE_PAGE_RELATED_COMPARE_PAGES_LIST_ID,
  RELATED_COMPARE_PAGES_LIST_ID,
} from './useFetchInternalLinkCards.constants'

export type InternalLinkCards = {
  hubRelatedComparePages: ArticleCard[]
  comparePageRelatedArticles: ArticleCard[]
  comparePageRelatedComparePages: ArticleCard[]
}

export function useFetchInternalLinkCards() {
  const $httpFetch = useHttpFetch()
  const { pathname } = useRequestURL()

  return async function fetchInternalLinkCards(): Promise<InternalLinkCards> {
    try {
      const response = await $httpFetch('/internal-links/v1/cards', {
        query: { source_url: pathname },
      })

      const map = Object.fromEntries(
        response.linkLists.map((linkList) => [
          linkList.listId,
          linkList.links.map((item) => ({
            title: item.title ?? '',
            text: item.description ?? '',
            id: item.link.href,
            imageSrc: item.image.src ?? '',
            link: { href: item.link.relativeHref },
            category: item.tagline ?? '',
            ...(item.image.alt ? { imageAlt: item.image.alt } : {}),
          })),
        ]),
      )

      return {
        hubRelatedComparePages: map[RELATED_COMPARE_PAGES_LIST_ID] ?? [],
        comparePageRelatedArticles:
          map[COMPARE_PAGE_RELATED_ARTICLES_LIST_ID] ?? [],
        comparePageRelatedComparePages:
          map[COMPARE_PAGE_RELATED_COMPARE_PAGES_LIST_ID] ?? [],
      }
    } catch {
      return {
        hubRelatedComparePages: [],
        comparePageRelatedArticles: [],
        comparePageRelatedComparePages: [],
      }
    }
  }
}
